// src/components/HeaderBar/index.tsx
import React, { useMemo, useState } from "react";
import { Menu, Dropdown, Modal } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useLocation, useNavigate, useModel } from "@umijs/max";
import "./style.less";
import { IconFont } from "@gatherstar/components";
import routes from "@/routes";
import type { AdvertiserUserDTO } from "@/services";
import { useMount } from 'ahooks';
import { GuangGaoZhuJianQuanGuanLiApi } from '@/services';
import { isOperation } from '@/utils/user';

interface UserInfo extends AdvertiserUserDTO {
  timezone?: string;
  timezoneArea?: string;
}

export const HeaderBar: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { initialState } = useModel("@@initialState");
  const currentUser = initialState?.currentUser as UserInfo | undefined;

  // 从路由配置生成菜单项，过滤掉 hideInMenu 的路由
  const menuItems = useMemo(() => {
    return routes
      .filter((route) => {
        return (
          !route.hideInMenu &&
          route.title &&
          !route.redirect &&
          route.path !== "*" &&
          !route.path.includes("/", 1)
        ); // 排除子路由，如 /asset-management/products-detail
      })
      .map((route) => ({
        key: route.path,
        label: route.title,
        icon: route.icon ? <IconFont type={route.icon} /> : null,
      }));
  }, []);

  // 根据当前路径匹配选中的菜单项
  const selectedKeys = useMemo(() => {
    const pathname = location.pathname;

    // 查找匹配的一级路由
    const matchedRoute = routes.find((route) => {
      if (route.hideInMenu || !route.title || route.redirect) {
        return false;
      }

      // 精确匹配
      if (pathname === route.path) {
        return true;
      }

      // 子路由匹配：如果当前路径以某个一级路由开头，则选中该一级路由
      return !!(route.path !== "/" && pathname.startsWith(route.path + "/"));
    });

    console.log("当前路径:", pathname, "选中的路由:", matchedRoute?.path);
    return matchedRoute ? [matchedRoute.path] : [];
  }, [location.pathname]);

  // 菜单点击处理
  const handleMenuClick = (e: { key: string }) => {
    navigate(e.key);
  };

  const handleUserMenuClick = ({ key }: { key: string }) => {
    if (key === "logout") {
      Modal.confirm({
        icon: <IconFont className="g-info" type="icon-circle-info" />,
        title: "退出登录",
        content: "确定要退出当前账号吗？",
        okText: "退出登录",
        cancelText: "取消",
        onOk: async () => {
          localStorage.removeItem("token");
          localStorage.removeItem("userInfo");
          navigate("/user/login");
        },
      });
      return
    }
    const item = userList.find((item) => item.advertiserId === Number(key))
    if (item) {
      GuangGaoZhuJianQuanGuanLiApi.getAdvertiserTokenInfoUsingPost(item.advertiserId).then(res => {
        window.location.href = '/?token=' + res
      })
    }
  };
  const [userList, setUserList] = useState<any>([])
  useMount(() => {
    if (isOperation()) {
      GuangGaoZhuJianQuanGuanLiApi.getImpersonateAdvertiserListUsingPost().then(res => {
        setUserList(res?.advertiserUserList || [])
      })
    }
  })
  const userMenu = (
    <Menu
      onClick={handleUserMenuClick}
      items={[
        // {
        //   key: "profile",
        //   label: currentUser?.advertiserId,
        //   icon: <IconFont className="!text-[18px]" type="icon-postcard" />,
        // },
        ...userList.map(item => {
          return {
            key: item.advertiserId,
            label: item.username,
            icon: <IconFont className="!text-[18px]" type="icon-postcard" />,
          }
        }),
        // {
        //   key: "profile",
        //   label: currentUser?.advertiserId,
        //   icon: <IconFont className="!text-[18px]" type="icon-postcard" />,
        // },
        {
          type: "divider",
        },
        ...(isOperation() ? [] : [{
          key: "logout",
          label: "退出登录",
          icon: (
            <IconFont className="!text-[18px]" type="icon-arrow_box_left" />
          ),
        }]),
      ]}
    />
  );

  return (
    <div className="custom-head w-full h-[60px] bg-[#0E131A] border-b border-[#30363d] text-white flex items-center justify-between px-3">
      {/* 左侧 Logo 与菜单 */}
      <div className="flex items-center">
        <img
          src="/icons/logo.svg"
          alt="logo"
          className="w-9 h-9 mr-6 cursor-pointer"
          onClick={() => navigate("/dashboard")}
        />

        <Menu
          mode="horizontal"
          selectedKeys={selectedKeys}
          items={menuItems}
          onClick={handleMenuClick}
          style={{
            background: "transparent",
            borderBottom: "none",
          }}
        />
      </div>

      {/* 右侧 时区 + 用户 */}
      <div className="flex items-center">
        {currentUser?.timezone && (
          <div
            className={"flex flex-col ml-2 mr-6 text-xs font-medium leading-5"}
          >
            <span className={"flex items-center text-[14px]"}>
              <IconFont className={"ml-[-26px] mr-2"} type="icon-clock" />
              {currentUser.timezone}
            </span>
            {currentUser.timezoneArea && (
              <span className={"text-[#929292]"}>
                {currentUser.timezoneArea}
              </span>
            )}
          </div>
        )}
        <Dropdown
          overlayClassName="user-dropdown"
          overlay={userMenu}
          placement="bottomRight"
        >
          <div className="user-drop">
            <IconFont className={"text-[20px]"} type="icon-people-circle" />
            <span>
              {currentUser?.nickName || currentUser?.username || "未登录"}
            </span>
            <IconFont className={"text-[20px]"} type="icon-dropdown" />
          </div>
        </Dropdown>
      </div>
    </div>
  );
};
